module.exports = __webpack_public_path__ + "img/phoxio-preview.6b13951f.jpg";